import getImage from "../../../ClinicEvent/components/PdfReports/GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import { calculateAgeParse } from "../../../../Utils/Patient";

const incapacityPDF = async (data) => {
  console.log("pdf de incapacidad", data);
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  const fecha = data.today;
  const name =
    data.typeOfDocument + "-" + data.documentNumber + " " + data.names;

  let urlServe =
    process.env.REACT_APP_PUBLIC_URL +
    "profesional/ver-firma/" +
    data.professional.id_profesional +
    "/" +
    sessionStorage.getItem("token");
  let urlFirma = "";

  let test = fetch(urlServe).then((response) => {
    if (response.status === 500) {
      return false;
    } else {
      return true;
    }
  });

  let isImg = await test;

  if (isImg) {
    urlFirma = urlServe;
  } else {
    urlFirma = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }

  let urlFirmaPaciente = "https://i.postimg.cc/0jznYVsr/prueba.png";

  let tableDiagnostics = [];
  let dataDiagnostic =
    data.diagnostics.addedDiagnostics !== null
      ? data.diagnostics.addedDiagnostics
      : [];
  console.log("dataDiagnostic", dataDiagnostic, typeof dataDiagnostic);
  tableDiagnostics.push([
    { text: "CIE-10 ", bold: true, style: "textStyleInfoTop" },
    { text: "Nombre", bold: true, style: "textStyleInfoTop" },
    { text: "Observación", bold: true, style: "textStyleInfoTop" },
  ]);

  try {
    for (let k = 0; k < data.diagnostics.addedDiagnostics.length; k++) {
      const element = dataDiagnostic[k];
      const observation = data.diagnostics.observations[k];
      tableDiagnostics.push([
        { text: element.codigo, style: "textStyleInfoTop" },
        { text: element.nombre, style: "textStyleInfoTop" },
        { text: observation, style: "textStyleInfoTop" },
      ]);
    }
  } catch (error) {
    console.log(error);
  }

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.nombre +
              "\nNit: " +
              data.profile.nit +
              "\n" +
              data.profile.direccion.direccion,
            style: "head",
          },
        ],
      ],
    },
  };

  /* const header = {
        margin: [5, 5, 5, 0],
        layout: 'noBorders',
        table: {
            heights: 40,
            widths: ['*', '*'],
            body: [
                [{
                    image: await getImage(data.urlLogo),
                    fit: [150, 75],
                },
                {
                    table: {
                        body: [
                            [{ text: data.profile.nombre, style: 'head', bold: true }],
                            [{ text: 'Dirección: ' + data.profile.direccion.direccion + ' ' + 'Teléfono:' + data.profile.telefono1, style: 'textStyle', bold: true }],
                            [{ text: 'NIT: : ' + data.profile.nit, style: 'head', bold: true }]
                        ]
                    },
                }],
            ],
        },
    }; */

  const foter = (currentPage, pageCount) => {
    return {
      table: {
        widths: ["*", "*", "*"],
        body: [
          [
            {
              text: "Página " + currentPage.toString() + " de " + pageCount,
              style: "foter",
            },
            { text: name, style: "foter" },
            { text: "Fecha Impresión: " + data.today, style: "foter" },
          ],
        ],
      },
      layout: "noBorders",
      margin: [20, 0, 0, 5],
    };
  };

  const documentDefinition = {
    pageSize: "LETTER",
    //pageOrientation: 'portrait',
    header: header,
    content: [
      {
        text: "CONSTANCIA DE INCAPACIDAD",
        style: "tableheader",
        alignment: "left",
        bold: true,
        margin: [0, 10, 0, 0],
      },
      {
        table: {
          headerRows: 1,
          widths: [520],
          body: [[""], [""]],
        },
        layout: "headerLineOnly",
      },
      {
        margin: [0, 0, 0, 0],
        layout: "noBorders",
        table: {
          widths: ["auto", "*", "auto", "*", "auto", "*"],
          border: [true, false, true, false],
          body: [
            [
              { text: "F.Ingreso: ", style: "textStyleInfoTop", bold: true },
              {
                text: data.fecha + " - " + data.hora,
                style: "textStyleInfoTop",
              },
              { text: "Documento", bold: true, style: "textStyleInfoTop" },
              {
                text: data.typeOfDocument + "-" + data.documentNumber,
                style: "textStyleInfoTop",
              },
              { text: "F.Nacimiento ", bold: true, style: "textStyleInfoTop" },
              {
                text: moment(data.birthday).format("DD-MM-YYYY"),
                style: "textStyleInfoTop",
              },
            ],
            [
              { text: "Paciente ", bold: true, style: "textStyleInfoTop" },
              { text: data.names, style: "textStyleInfoTop", colSpan: 3 },
              "",
              "",
              { text: "Edad ", bold: true, style: "textStyleInfoTop" },
              {
                text: calculateAgeParse(data.birthday),
                style: "textStyleInfoTop",
              },
            ],
            [
              { text: "Dirección ", bold: true, style: "textStyleInfoTop" },
              { text: data.direccion, style: "textStyleInfoTop", colSpan: 3 },
              "",
              "",
              { text: "Celular: ", bold: true, style: "textStyleInfoTop" },
              { text: data.celular, style: "textStyleInfoTop" },
            ],
            [
              { text: "Medico ", bold: true, style: "textStyleInfoTop" },
              {
                text:
                  data.professional.nombres +
                  " " +
                  data.professional.apellido1 +
                  " " +
                  data.professional.apellido2,
                style: "textStyleInfoTop",
                colSpan: 3,
              },
              "",
              "",
              {
                text: "Autorización No. ",
                bold: true,
                style: "textStyleInfoTop",
              },
              {
                text: data?.infoAdmission?.admision?.codigo_autorizacion,
                style: "textStyleInfoTop",
              },
            ],
            [
              { text: "Entidad: ", style: "textStyleInfoTop", bold: true },
              { text: data.thirdName, style: "textStyleInfoTop", colSpan: 3 },
              "",
              "",
              {
                text: "Validación No. ",
                bold: true,
                style: "textStyleInfoTop",
              },
              {
                text: data?.infoAdmission?.admision?.codigo_validacion,
                style: "textStyleInfoTop",
              },
            ],
          ],
        },
      },
      {
        table: {
          headerRows: 1,
          widths: [520],
          body: [[""], [""]],
        },
        layout: "headerLineOnly",
      },
      data.infoIncapacityCurrentAdmision !== null
        ? {
            unbreakable: true,
            margin: [0, 5, 0, 10],
            layout: "noBorders",
            table: {
              widths: ["auto", "*", "auto", "*"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "Días de incapacidad: ",
                    style: "textStyleInfoTop",
                    bold: true,
                    alignment: "rigth",
                  },
                  {
                    text: data.infoIncapacityCurrentAdmision[0]
                      ?.dias_incapacidad,
                    style: "textStyleInfoTop",
                    alignment: "rigth",
                  },
                  {
                    text:
                      "Fecha de inicio: " +
                      moment(
                        data.infoIncapacityCurrentAdmision[0]?.fecha_incial
                      ).format("DD-MM-YYYY"),
                    style: "textStyleInfoTop",
                    bold: true,
                    alignment: "left",
                  },
                  {
                    text:
                      "Fecha en la que termina: " +
                      moment(
                        data.infoIncapacityCurrentAdmision[0]?.fecha_final
                      ).format("DD-MM-YYYY"),
                    style: "textStyleInfoTop",
                    bold: true,
                    alignment: "left",
                  },
                ],
              ],
            },
          }
        : null,
      dataDiagnostic !== null
        ? {
            text: "Diagnóticos que generan la incapacidad",
            style: "textStyleInfoTop",
            bold: true,
          }
        : null,
      dataDiagnostic !== null
        ? {
            unbreakable: true,
            margin: [0, 5, 0, 10],
            layout: "noBorders",
            table: {
              widths: ["auto", "*", "*"],
              headerRows: 1,
              body: tableDiagnostics,
            },
          }
        : null,
      data.infoIncapacityCurrentAdmision !== null
        ? {
            unbreakable: true,
            margin: [0, 5, 0, 10],
            layout: "noBorders",
            table: {
              widths: ["auto", "*"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "Observaciones: ",
                    style: "textStyleInfoTop",
                    bold: true,
                  },
                  {
                    text: data.infoIncapacityCurrentAdmision[0]?.observaciones,
                    style: "textStyleInfoTop",
                  },
                ],
              ],
            },
          }
        : null,
      {
        // auto-sized columns have their widths based on their content
        columns: [
          /* {
                        // auto-sized columns have their widths based on their content                                       
                        margin: [20, 10, 25, 0],
                        layout: 'headerLineOnly',
                        table: {
                            widths: [100],
                            headerRows: 1,
                            body: [
                                [{
                                    image: await getImage(urlFirma),
                                    fit: [35, 35],
                                }],
                                [{ text: 'Firma y Cedula', style: 'tableText', }],
                            ]
                        },
                    }, */
          {
            // auto-sized columns have their widths based on their content
            margin: [40, 30, 25, 0],
            layout: "headerLineOnly",
            table: {
              widths: [100],
              headerRows: 1,
              body: [
                [
                  {
                    image: await getImage(urlFirma),
                    fit: [80, 80],
                  },
                ],
                [
                  {
                    text: `Dr. ${data.professional.nombres} ${data.professional.apellido1} ${data.professional.apellido2}
                    ${data.professional.especialidad} \n REG-${data.professional.reg_medico} `,
                    style: "medicStyle",
                  },
                ],
              ],
            },
          },
        ],
        columnGap: 40,
      },
      {
        text: "Favor tramitar la incapacidad antes de 72 horas",
        style: "textStyleInfoTop",
        alignment: "center",
        bold: true,
        margin: [0, 10, 0, 0],
      },
    ],
    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        font: "OpenSans",
      },
      tableheader: {
        fontSize: 10,
        bold: true,
        font: "OpenSans",
      },
      textStyle: {
        fontSize: 9,
        font: "OpenSans",
      },
      textStyleInfoTop: {
        fontSize: 8,
        font: "OpenSans",
      },
      paragraf: {
        fontSize: 10,
        alignment: "justify",
        font: "OpenSans",
      },
      foter: {
        margin: 10,
        fontSize: 6,
        font: "OpenSans",
      },
      medicStyle: {
        fontSize: 9,
        alignment: "center",
        bold: true,
        font: "OpenSans",
      },
      tableText: {
        fontSize: 8,
        font: "OpenSans",
      },
    },
  };

  //pdfMake.createPdf(documentDefinition).open();
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });
};

export default incapacityPDF;
